<template>
    <v-container class="max-height">
        <v-row>
            <v-col>
                <h1 class="text-left">Assets Summary</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col v-if="user.type === 'admin'" cols="12" md="2" sm="4">
                <company-select v-model="formData['company']" :items="companiesList"
                          density="compact" label="Select Company"
                          @update:model-value="()=>{fetchAssetList();fetchReport(true);}"/>
            </v-col>
            <v-col cols="12" md="2" sm="4">
                <v-select v-model="formData['assets']" :items="assetsList" chips clearable
                          density="compact" item-title="label" item-value="id" label="Select Asset(s)" multiple
                          @update:model-value="()=>{fetchAssetList();fetchReport(true)}"/>
            </v-col>
            <v-col cols="12" md="2" sm="4">
                <v-date-input
                    v-model="formData['start_date']"
                    append-inner-icon="$calendar"
                    clearable
                    density="compact"
                    hide-actions
                    label="Start Date"
                    prepend-icon=""
                    @click:clear="()=>{formData['start_date']=null;fetchReport(true)}"
                    @update:model-value="fetchReport(true)"/>
            </v-col>
            <v-col cols="12" md="2" sm="4">
                <v-date-input
                    v-model="formData['end_date']"
                    append-inner-icon="$calendar"
                    clearable
                    density="compact"
                    hide-actions
                    label="End Date"
                    prepend-icon=""
                    @click:clear="()=>{formData['end_date']=null;fetchReport(true)}"
                    @update:model-value="fetchReport(true)"/>
            </v-col>
            <v-col cols="auto" class="d-flex align-center">
                <v-btn :loading="downloading" prepend-icon="mdi-download" size="small" variant="tonal"
                       @click="exportCsv">Export CSV</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-table class="text-start">
                    <thead>
                    <tr>
                        <td class="text-h6">Trips</td>
                        <td class="text-h6">Fuel Refills</td>
                        <td class="text-h6">Maintenance</td>
                        <td class="text-h6">Inspection</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Distance:
                            <b>{{
                                    strOperations().unitifyDistance(trip_total_counts['total_distance'], 'distance', 'km')
                                }}</b>
                        </td>
                        <td>Avg Cost Per Unit: <b>${{
                                fuelStats['avg_cost_per_unit'] ? parseFloat(fuelStats['avg_cost_per_unit']).toFixed(2) : 0
                            }}</b></td>
                        <td>Skipped: <b>{{ stats['maintenance']['skipped'] }}</b></td>
                        <td>Skipped: <b>{{ stats['inspection']['skipped'] }}</b></td>
                    </tr>
                    <tr>
                        <td>Drivers: <b>{{ trip_total_counts['drivers'] }}</b></td>
                        <td>Total Cost: <b>${{
                                fuelStats['total_cost'] ? parseFloat(fuelStats['total_cost']).toFixed(2) : 0
                            }}</b></td>
                        <td>Pending: <b>{{ stats['maintenance']['pending'] }}</b></td>
                        <td>Pending: <b>{{ stats['inspection']['pending'] }}</b></td>
                    </tr>
                    <tr>
                        <td>Total: <b>{{ trip_total_counts['total_trips'] }}</b></td>
                        <td>Total: <b>{{ fuelStats['count'] }}</b></td>
                        <td>Completed: <b>{{ stats['maintenance']['completed'] }}</b></td>
                        <td>Completed: <b>{{ stats['inspection']['completed'] }}</b></td>
                    </tr>
                    <tr>
                        <td>-</td>
                        <td>-</td>
                        <td>Total: <b>{{ stats['maintenance']['count'] }}</b></td>
                        <td>Total: <b>{{ stats['inspection']['count'] }}</b></td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <h2 class="mt-5 text-start">Fuel Average</h2>
            </v-col>
            <v-col cols=12>
                <v-table>
                    <thead>
                    <tr>
                        <th>Fuel</th>
                        <th>Distance</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in fuelAverage" v-if="fuelAverage.length" class="text-left">
                        <td>{{ item.fuel_type }}</td>
                        <td>{{ item.avg == null ? '-' : `${strOperations().unitifyDistance(item.avg, 'distance', 'km')} /unit` }}</td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="3">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="3">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <h2 class="mt-5 text-start">Trip Stats</h2>
            </v-col>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Avg. Trips Per Day</th>
                        <th>Avg. Distance Per Day</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in reportData" v-if="reportData.length" class="text-left">
                        <td>{{ item.date }}</td>
                        <td>{{ item.avg_trips_per_day }}</td>
                        <td>{{ strOperations().unitifyDistance(item.avg_distance_per_day, 'distance', 'km') }}</td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="3">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="3">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchReport(false)"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import {onMounted, reactive, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {strOperations} from "@/composables/globals";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {useReportExport} from "@/composables/useReportExport";
import {VDateInput} from "vuetify/lib/labs/VDateInput";
import CompanySelect from "@/components/globals/company-select.vue";

const {user} = useAuthStore();
const {downloadReport} = useReportExport();
const reportData = ref([]);
const totalPages = ref(1);
const loading = ref(false);
const downloading = ref(false);
const currentPage = ref(1);
const assetsList = ref([]);
const fuelAverage = ref([]);
const companiesList = ref([]);
const {showSnackbar} = useSnackbarStore();
const stats = ref({
    'maintenance': {
        'count': 0,
        'pending': 0,
        'skipped': 0,
        'completed': 0,
        'cost': 0.0,
    },
    'inspection':
        {
            'count': 0,
            'pending': 0,
            'skipped': 0,
            'completed': 0,
            'cost': 0.0,
        }
});
const fuelStats = ref({
    'counts': 0,
    'total_cost': 0,
    'avg_cost_per_unit': 0,
});
const trip_total_counts = ref({
    'total_trips': 0,
    'total_distance': 0,
    'drivers': 0,
});
const formData = reactive({
    company: ref(user.type !== 'admin' ? user.company.id : null),
    start_date: null,
    end_date: null,
    assets: null,
    rows: 10,
});

onMounted(() => {
    if (user.type === 'admin') {
        fetchCompaniesList();
    } else {
        fetchReport();
        fetchAssetList();
    }
})

const fetchCompaniesList = () => {
    send('get', `companies/list`)
        .then((response) => {
            companiesList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Companies List could not be loaded', 'error')
        })
}
const fetchAssetList = () => {
    return send('get', `assets/list`, {company: formData['company']})
        .then((response) => {
            assetsList.value = response.data.data;
        })
        .catch((error) => {
            showSnackbar('Assets List could not be loaded', 'error')
        })
}
const exportCsv = async () => {
    downloading.value = true
    try {
        await downloadReport('fleet/reports/assets-summary-report', formData, 'csv', 'assets-summary.csv')
    } catch {
        showSnackbar('Export failed', 'error')
    } finally {
        downloading.value = false
    }
}

const fetchReport = (reset = false) => {
    loading.value = true;
    if (reset) {
        totalPages.value = 1;
        currentPage.value = 1;
        reportData.value = [];
    }
    send('get', `fleet/reports/assets-summary-report`, {...formData, page: currentPage.value})
        .then((response) => {
            stats.value = response.data.data.stats;
            fuelStats.value = response.data.data.fuelStats;
            fuelAverage.value = response.data.data.fuelAverage;
            trip_total_counts.value = response.data.data.trip_total_counts;
            reportData.value = response.data.data.trip_counts_per_day?.data;
            totalPages.value = response.data.data.trip_counts_per_day?.last_page;
            currentPage.value = response.data.data.trip_counts_per_day?.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Assets summary report could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
</script>
